import {
    SimplePresentation,
    SimplePresentationRunnerController
} from "./SimplePresentationRunner";
import {FlightMode} from "../FlightMode";
import {gsap} from "gsap";
import {FlightModeSound} from "../misc/FlightModeSound";

export class FreeSpinsOutro implements SimplePresentation {

    name:string = "FreesSpinOutro";

    public shouldRun():boolean {
        return !FlightMode.model.brokeTheBank && FlightMode.model.freespinsIsFinished();
    }

    public start(controller:SimplePresentationRunnerController):void {
        const tl = gsap.timeline();

        tl.add(() => {
            controller.setSkipCallback(() => {tl.progress(1, false)});
        });

        tl.add(() => {
            FlightMode.keypadPlugin.setZeroBetSpinCounter(-1);
            FlightMode.soundPlayer.fadeOutMusic();
            if (!FlightMode.isWinBelowStake() && FlightMode.model.accumulatedRoundWin > 0)
                FlightMode.soundPlayer.playSound("fsOutroCountUp");
        }, '>0.8');

        tl.add(FlightMode.transitionScreen.freespinsOutro.show(), '<');

        if (!FlightMode.isWinBelowStake() && FlightMode.model.accumulatedRoundWin > 0)
            tl.add(() => {FlightMode.soundPlayer.playSound("fsOutroCountUpEnd")}, '>-0.6')

        tl.add(() => {
            if (!FlightMode.isWinBelowStake())
                FlightMode.soundPlayer.playSound("fsOutroRevealStuff");
            FlightMode.transitionScreen.enableButton(() => {
                FlightMode.backgroundElements.setToBaseGame();
                FlightMode.transitionScreen.freespinsOutro.hide();
                FlightMode.soundPlayer.stopSound("fsOutroLoop")
                FlightMode.soundPlayer.stopSound("sfsOutroLoop")
                FlightMode.keypadPlugin.show();
                FlightMode.soundPlayer.switchMusic(FlightModeSound.BASE_GAME_MUSIC);
                FlightMode.soundPlayer.fadeInMusic(0);
                controller.finish()
            });
            FlightMode.soundPlayer.playLoopingSound("fsOutroLoop");
            FlightMode.soundPlayer.stopSound("fsOutroCountUp");
            FlightMode.soundPlayer.stopSound("fsOutroCountUpEnd");
            controller.setSkipCallback();
        });
    }
}